import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  OccupationDetailState,
  occupationDetailFeatureKey
} from './occupation-detail.state';
// Feature selector
export const selectOccupationDetailState =
  createFeatureSelector<OccupationDetailState>(occupationDetailFeatureKey);

// Selectors
export const selectOccupationDetail = createSelector(
  selectOccupationDetailState,
  (state) => state.occupationDetail
);

export const selectOccupationLoadFailure = createSelector(
  selectOccupationDetailState,
  (state) => state.occupationLoadFailure
);

export const selectOccupationForExportPdf = createSelector(
  selectOccupationDetailState,
  (state) => state.occupationForExportPdf
);
